export const WORK_DIR_NAME = 'project';
export const WORK_DIR = `/home/${WORK_DIR_NAME}`;
export const MODIFICATIONS_TAG_NAME = 'alpha_file_modifications';
export const USER_PROMPT = 'user_prompt';
export const FIGMA_META_DATA = 'figma_meta_data';
export const API_SPEC_TAG_NAME = 'open_api_spec';
export const API_SPEC_METHOD_NAME = 'open_api_spec_method';
export const PROJECT_RULES_TAG_NAME = 'project_rules';
export const GLOBAL_RULES_TAG_NAME = 'global_rules';
export const SUPABASE_CONTEXT_TAG_NAME = 'supabase_context';
export const SECURITY_ADVISORY_TAG_NAME = 'security_advisory';
export const REF_IMAGE_TAG_NAME = 'ref_image';
export const ASSETS_TAG_NAME = 'attached_assets';

export const claude_sonnet_4 = 'claude-sonnet-4-20250514';
export const claude_sonnet_3_7 = 'claude-3-7-sonnet-20250219';
export const claude_sonnet_3_5 = 'claude-3-5-sonnet-20240620';
export const claude_haiku_3_5 = 'claude-3-5-haiku-20241022';

// GCP (Google Vertex) model IDs
export const gcp_claude_sonnet_4 = 'claude-sonnet-4@20250514';
export const gcp_claude_sonnet_4_5 = 'claude-sonnet-4-5@20250929';
export const gcp_gemini_pro = 'gemini-3.1-pro-preview';
export const gcp_gemini_3_flash = 'gemini-3-flash-preview';
export const gcp_gemini_flash = 'gemini-2.5-flash';
export const gcp_glm_5 = 'glm-5-maas';

// AWS (Bedrock) model IDs — `us.` cross-region inference profiles
export const aws_claude_sonnet_5 = 'global.anthropic.claude-sonnet-4-6'; // sonnet 5 is not working for now
export const aws_claude_sonnet_4_5 = 'global.anthropic.claude-sonnet-4-5-20250929-v1:0'; // sonnet 5 is not working for now
export const aws_claude_haiku_4_5 = 'us.anthropic.claude-haiku-4-5-20251001-v1:0';
export const aws_nova_2_lite = 'us.amazon.nova-2-lite-v1:0';

export const isDev = true;
export const tabViewEnabled = true;

export const Free_Git_Repo_Size = 25; // 25MB
export const Pro_Git_Repo_Size = 25; // 25MB

export const Free_Git_Repo_Tokens = 100000; // 1 lakh characters
export const Pro_Git_Repo_Tokens = 400000;
export const max_commit_length = 150;

export const Pro_Git_Repo_Limit = 500; // 500MB
export const Free_Git_Repo_Limit = 100; // 100MB

export const Pro_Total_Repos_Limit = 500; // 500 repos
export const Free_Total_Repos_Limit = 100; // 100 repos

// otp rate limit constants
export const OTP_SEND_LIMIT_PER_EMAIL = 6; // max sends per email per window
export const OTP_SEND_LIMIT_PER_IP = 6; // max sends per IP per window
export const OTP_SEND_WINDOW_SECONDS = 300; // 5-minute window
export const OTP_TTL_SECONDS = 300; // OTP valid for 5 minutes

export const MAX_REQUESTS_PER_MINUTE = 10; // max ai API requests per minute

export const MAX_FAIL_ATTEMPTS_PER_OTP = 6; // after this many wrong guesses the OTP is invalidated
export const VERIFY_LIMIT_PER_EMAIL = 6; // max verify attempts per email per window
export const VERIFY_LIMIT_PER_IP = 6; // max verify attempts per IP per window
export const VERIFY_WINDOW_SECONDS = 300; // 5-minute window

export const Special_Users = ['shivgun03@gmail.com', 'santosh.ganti@bprhub.com', 'kachmaryk777@gmail.com'];
export const Team_Users = [
  'shivgun03@gmail.com',
  'shivam@dualite.dev',
  'sayanmajumder0002@gmail.com',
  'vaibhavi@dualite.dev',
  'prakhar@dualite.dev',
  'ptofficial29@gmail.com',
  'mdubey.0433@gmail.com',
  'mukul@dualite.dev',
  'rohan@dualite.dev',
];

export const Index_DB_quota = 800; // 200 MB

// constants for FigmaOAuthModal
export const THRESHOLD_SIZE = 2; // 2MB
export const MAX_SIZE = 5; // 4MB
export const MAX_ASSET_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_PROJECT_ASSETS = 10; // 10 assets (currently only images are supported)
export const MAX_DIMENSION = 8000; // 8000px]
export const MAX_JSON_TOKENS = 150000;
export const TARGET_LONGEST_EDGE = 768;
export const TARGET_MIN_SCALE = 0.25;
export const MAX_ATTACHED_IMAGES = 2;

// Asset upload restrictions (client-side validation; server should still validate as well)
export const ALLOWED_ASSET_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'] as const;
export const ALLOWED_ASSET_VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.avi'] as const;

export const DUALITE_COMMUNITY_SPREADSHEET_ID = '1J3llbabGrh_W4ncZM4X-GIGKyWQ_1h_25Xp6hJJ-tWQ';

export const FREE_USER_PROMPTS = 5;
export const MAINTENANCE_MODE = false;

export const FILE_ACTION_BUCKET_NAME = 'files-dualite';

export const PROJECT_ARCHIVE_BUCKET_NAME = isDev ? 'projects-dev-dualite' : 'project-archives-dualite';

// Asset Processing Buckets
export const ASSET_BUCKETS = {
  IMAGES_RAW: 'images-raw-dualite',
  VIDEOS_RAW: 'videos-raw-dualite',
  IMAGES_FINAL: 'images.dualite.app',
  VIDEOS_FINAL: 'videos.dualite.app',
} as const;

// Asset Upload Configuration
export const ASSET_UPLOAD_CONFIG = {
  DEFAULT_CHUNK_SIZE: 8 * 1024 * 1024, // 8MB
  DEFAULT_RETRIES: 5,
  MAX_FILE_SIZE_IMAGE: 5 * 1024 * 1024, // 10MB
  MAX_FILE_SIZE_VIDEO: 10 * 1024 * 1024, // 500MB
} as const;

export type PaidTemplateStatus = 'PENDING' | 'ACTIVE';

export const PTK = {
  SOHO: 'soho',
  CONVERGEAI: 'convergeai',
  SOOTHEMI: 'soothemi',
  HORAI: 'horai',
  AISELFIEVIDEO: 'aiselfievideo',
  YELLOWSTUDIO: 'yellowstudio',
  JANEAIAGENCY: 'janeaiagency',
  NORDEN: 'norden',
  ONERESERVE: 'onereserve',
  JENNYHUPORTFOLIO: 'jennyhuportfolio',
  BATMANPORTFOLIO: 'batmanportfolio',
  CLAYMIST: 'claymist',
  FIGJAMFLOWCHART: 'figjamflowchart',
  INVESTIFY: 'investify',
  AIFASHIONSTUDIO: 'aifashionstudio',
  DONTDIESINGLE: 'dontdiesingle',
  TYPEWRITER: 'typewriter',
  MEMORYLANE: 'memorylane',
  SUPERMARIO: 'supermario',
  VANGOGHSTYLER: 'vangoghstyler',
  AIVOICERECEPTIONIST: 'aivoicereceptionist',
  HRDASHBOARD: 'hrdashboard',
  POMODOROTODO: 'pomodorotodo',
  SNEAKERSECOMMERCE: 'sneakersecommerce',
  SKETCHENHANCE: 'sketchenhance',
  MUNCHR: 'munchr',
  NOVAPAY: 'novapay',
  CLEERFINANCE: 'cleerfinance',
  STRATONAI: 'stratonai',
  IGNITECOFFEE: 'ignitecoffee',
  LORVIQUE: 'lorvique',
} as const;

export type PTKValue = (typeof PTK)[keyof typeof PTK];

export const REFRESH_TOKEN_BUFFER = 5 * 60 * 1000; // 5 minutes in milliseconds

export const SHOW_ALERT_LIMIT = 5; // 5 prompts remaining to show alert in the prompt quota indicator
// Keep browser-metro package requests on the app origin. The Remix proxy behind
// this path forwards them to https://rn-server.dualite.dev, avoiding browser
// CORS failures without exposing a general-purpose proxy.
export const RN_PACKAGE_SERVER_URL = '/api/rn-packages';
